var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ListService } from './list.service';
import { ReadonlyService } from '../../items/columns/readonly/readonly.service';
import { Angular2Csv } from 'angular2-csv';
var CsvComponent = /** @class */ (function (_super) {
    __extends(CsvComponent, _super);
    function CsvComponent(router, route, logger, action, message, page, service, readonlyService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.readonlyService = readonlyService;
        _this.events = { csv: 'csv' };
        _this.dispBtn = true;
        return _this;
    }
    CsvComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        var params = this.component.params || {};
        this.groupName = this.service.getGroupName(params.groupName);
        this.dispBtn = this.action.validEvent(this.events.csv);
    };
    CsvComponent.prototype.setUnsubscribe = function () {
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    CsvComponent.prototype.onSubscribe = function (data) {
        if (typeof data !== 'undefined') {
            var headers = this.getHeaders();
            var recs = this.getData(headers, JSOG.parse(JSON.stringify(data.items)));
            var filename = (this.component.params && this.component.params.filename ? this.component.params.filename : 'filename');
            var addDate = jsonpath.value(this.component, '$.params.addDate') || false;
            if (addDate === true) {
                filename = filename + moment().format('YYYYMMDDHHmmss');
            }
            new Angular2Csv(recs, filename, { showLabels: true, headers: headers });
        }
    };
    CsvComponent.prototype.onEventSubscribe = function (e) {
        if (e === this.componentName + '#Button#csv') {
            var query = this.service.convertQuery(this.service.getCurrentQuery(this.groupName));
            query.limit = null;
            query.offset = 0;
            this.service.getQuery(query, '$csv' + this.groupName);
            this.action.firstAction(this.events.csv, { queryGroupName: '$csv' + this.groupName });
        }
    };
    CsvComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    CsvComponent.prototype.getHeaders = function () {
        var headers = [];
        for (var i = 0; i < this.cols.length; i++) {
            var col = this.cols[i];
            if (typeof col.label !== 'undefined') {
                headers.push(col.label);
            }
            else {
                headers.push('col' + i);
            }
        }
        return headers;
    };
    CsvComponent.prototype.getData = function (headers, recs) {
        var listData = [];
        for (var _i = 0, recs_1 = recs; _i < recs_1.length; _i++) {
            var rec = recs_1[_i];
            var data = {};
            for (var i = 0; i < this.cols.length; i++) {
                var col = this.cols[i];
                var key = headers[i];
                if (col.items) {
                    var vals = [];
                    for (var _a = 0, _b = col.items; _a < _b.length; _a++) {
                        var item = _b[_a];
                        vals.push(this.readonlyService.getValue(this.componentName, item, rec[item.key], 'label'));
                    }
                    data[key] = vals.join('');
                }
                else {
                    data[key] = this.readonlyService.getValue(this.componentName, col, rec[col.key], 'label');
                }
            }
            listData.push(data);
        }
        return listData;
    };
    CsvComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'csv',
                    template: "<btn *ngIf=\"dispBtn\" [componentName]=\"componentName\"\n     [component]=\"{\n        params: {\n          buttons: [{\n            type: 'button',\n            event: componentName + '#Button#csv',\n            caption: (msg | async)['CsvComponent.button.download']\n          }]\n        }\n}\"></btn>\n"
                }] }
    ];
    /** @nocollapse */
    CsvComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ListService },
        { type: ReadonlyService }
    ]; };
    return CsvComponent;
}(ContentBaseComponent));
export { CsvComponent };
//# sourceMappingURL=csv.component.js.map